export default {
  copyright: `Copyright © ${new Date().getFullYear()} HABOOK Group TEAM Model`,
  logout: "Logout",
  productName:'HiTeach Mind',
  markDownErr:'Markdown format error',
  markDownNote:'Please enter the correct Markdown format',
  defaultMind:{
    templateName:'Mind map Template',
    root:'Mind map Topic',
    node1:'Node 1',
    node2:'Node 2',
    node3:'Node 3',
    node4:'Node 4',
  },
  mainMenu: {
    gotoHome: "My Dashboard",
    rename: "Rename",
    import: "Import",
    inputMD: "Markdown File",
    pasteMD: "Markdown Text",
    copyMD: "Copy Text",
    export: "Export",
    downloadMD: "Markdown (.md)",
    downloadImage: "Image",
    exportStaticMindmap: "Publish Display (Static Mind Map)",
    copyToMyDocuments: "Copy to My Documents",
    createCopy: "Create a Copy",
    alreadyCopied: "Copied to Clipboard",
    coworkMode: "Cowork",
    backCollect: "Back to Collection",
    deleteMindMap: "Delete Mind Map",
  },
  downloadImageSuccess: "Image downloaded successfully",
  downloadImageFailed: "Failed to download image",
  generateImageFailed: "Failed to generate image",
  staticMindmap: {
    title: "Mind Map Topic",
    urlLabel: "Private Link URL：",
    publicUrlLabel: "Public Display URL：",
    copied: "URL copied to clipboard",
    loadFailed: "Failed to load static mind map",
    publishDialogTitle: "Publish Display",
    modePrivate: "Private Link",
    modePrivateDesc: "Only for yourself, not public",
    modePublic: "Public Display",
    modePublicDesc: "Anyone can search and browse",
    publishTitle: "Display Title",
    publishDescription: "Mind Map Description (optional)",
    publishDescriptionPlaceholder: "Enter description...",
    publishTags: "Tags (comma-separated)",
    publishBtn: "Publish",
    publishing: "Publishing...",
    publishSuccess: "Published! Go to 'Public Display Manager' to view or delete.",
    overwriteHint: "This will replace the current public version in the Gallery.",
    overwriteSuccess: "The public display file already exists and has been updated by overwriting the existing version!",
  },
  phoneticFont: {
    loading: "Loading phonetic font...",
    loadFailed: "Failed to load phonetic font",
  },
  anonymousNameBox: {
    placeholder: "Please enter a name (10 characters or less)",
    welcomeTitle: 'Welcome to HiTeach Cloud Mind Map',
    title: "Quick Use Without Login",
    or: 'or',
    save: "Use This Name",
    loginHint:"Login/Apply account to use"
  },
  renameBox: {
    title: "Rename",
    save: "Save Changes",
  },
  coworkMode: {
    edit: "Collaboration Mode",
    view: "Read-Only Mode",
  },
  mindmapTypeSelection: {
    title: "Please select HiTeach mind map type",
    localMindmap: "Create a local mind map",
    cloudMindmap: "Reference a cloud mind map",
  },
  unsupportFC: "Sharing website does not currently support this feature!",
  auth: {
    notLoggedInShareWarning: "You are not logged in and cannot perform sharing operations. Please log in first and try again."
  },
  initializeFluidRelay: "Initializing container... Please wait",
  cannotConnect: "Cannot connect to server. Please check network connection or try again later",
  tryingToGetContainer:'Trying to get data... Please wait',
  disconnected: "Detected a connection interruption or other errors. Please check the network and refresh the page before trying again",
  initializeOK: "Initialization Successful",
  initializeFailed: "Initialization Failed, please check the URL, if the URL is correct, please check if the owner has deleted the content",
  cannotMoveToChild: "Cannot move to your own child node",
  saveOK: "Save Successful",
  saveFailed: "Save Failed",
  alreadyDeleted: "Already Deleted",
  snapshoting: "Taking Screenshot ~",
  updateSnapshot: "Update Screenshot",
  relayout: "Reorganizing ~",
  tooManyUsers: "Currently too many users online, more than 100 people, may have communication delay, please try again later.",
  userLimitReached: "User Limit Reached",

  新增: "New Node",
  編輯: "Edit Node",
  輸入文字: "Type something...",
  確定: "OK",
  取消: "Cancel",
  請先選取節點: "Please select a node first!",
  不可刪除有子項目的節點: "Nodes with sub-projects cannot be deleted!",
  新增失敗: "The new failed, the parent node has been deleted!",
  編輯失敗: "Editor failed, the selected node has been deleted!",
  加入根節點: "Add Root Node",
  左邊: "Left",
  右邊: "Right",
  已是最上面: "Already on top!",
  已是最下面: "Already at the bottom!",
  圖片: "Image",
  圖片過大提示字1: "The selected image is too large (please keep it under",
  圖片過大提示字2: "MB). Please choose another one!",
  連結: "Link",
  連結網址: "Link URL",
  連結名稱: "Link Name",
  輸入URL: "Enter URL...",
  輸入連結名稱: "Enter link name...",
  註解: "Annotation",
  進階設定: "Advanced Settings",
  線條顏色: "Line Color",
  節點顏色: "Node Color",
  preEditHint: "Note: The previous editor of the current node is",
  confirmUpdate: ", are you sure you want to modify it?",
  moveNodeTitle: "Move Node",
  moveNodeHint: "Please select a parent node.",
  noTopic: "no topic",
  menu: {
    新增: "Add",
    刪除: "Delete",
    上移: "Move up",
    下移: "Move down",
    左移:'Move left',
    右移:'Move right',
    編輯: "Edit",
    複製: "Copy",
    檢視圖片: "View image",
    最後更新: "Last update",
    檢視節點變更記錄: "View node change log",
    lock: "Lock",
    unlock: "unlock",
    locked: "locked",
    move: "Move",
    applyColor: "Apply Color",
    applyColorSuccess: "Color applied to all child nodes",
    more: "More",
    allRightLayout: "All Right Layout",
    allRightLayoutSuccess: "All first-level child nodes adjusted to right layout",
    allLeftLayout: "All Left Layout",
    allLeftLayoutSuccess: "All first-level child nodes adjusted to left layout",
    noChildrenToApply: "Root node has no child nodes to apply",
    expandAll: "Expand All",
    collapseAll: "Collapse All",
    lockAll: "Lock All",
    unlockAll: "Unlock All",
  },
  treeMenu: {
    currentMoveNode: "The node (including its child nodes) to be moved.",
    selectedParentNode: "Set as parent node",
  },
  imgEditor: {
    詢問離開動作: "Choose an Action",
    保存圖片: "Save Image",
    捨棄變更: "Discard Changes",
    取消: "Cancel",
  },
  mindCollectPage:{
    viewURL:"View link",
    viewEditKey: "View edit password",
    deleteMindMap:"Delete mind map",
    editKey: "Edit password:",
    url:"Link:",
    submitMindMap: "Submit a mind map",
    createRefer:"Edit mind map draft",
    useTemplate:"Use template",
    seatNum: "Seat No.",
    name:"Name",
    inputNum: "Enter a number",
    inputName: "Enter your name",
    topic:"Topic",
    newTopic: "New collection area",
    searchTopic: "Search name...",
    submitClose: "Collection has stopped!",
    viewClose: "It has been set to not allow clicks to view content!",
    templateTips: "Tips: After creation, you can click Edit Template to let users use it as a reference for submitting assignments",
    refreshing: "Refreshing...",
    refreshSuccess: "Refresh complete",
  },
  mindmapHome: {
    login: "Login",
    logout: "Logout",
    logoutOK: "Logged out~",
    share: "Share Status",
    shareShort:'Share',
    delete: "Delete",
    rename: "Rename",
    detailInfo: "Detailed Information",
    copy: "Copy",
    renameFile: "Rename File",
    save: "Save Changes",
    haveLinkCanDo: "Anyone with the link can",
    closeShare: "Close Sharing",
    publishShare: "Publish Sharing",
    publishAsAssignmentTemplate: "Publish as Assignment Template",
    comfirmDelete: "Are you sure you want to delete this mind map?",
    mindmapCreator: "Creator",
    mindmapEditor: "Last Updated By",
    createTime: "Creation Time",
    updateTime: "Update Time",
    coworkMode: "Collaboration Mode",
    myMindMap: "My Mind Maps",
    myMindMapBtn: "My Mind Maps",
    search: "Search",
    add:'+ Add',
    addFile: "Mind Map",
    addCoworkMindMap:'Collaborative Mind Map',
    addMindCollect:'Mind Map Task',
    addCollectNormal:'General Folder',
    mindmapName: "Name",
    noData: "No Data Available",
    true: "Yes",
    false: "No",
    setCoworkInHTinfo: "When used in HT, forces Sharing files to be set to Collaboration Mode",
    initialize: "Initializing... Please wait",
    initializeFailed: "Initialization Failed",
    deleting: "Deleting... Please wait",
    deletingOKinFront: "Delete Successful",
    cannotConnect: "Cannot connect, please check your network",
    saveOk: "Save Successful",
    saveFailed: "Save Failed",
    confirmDelete:'Confirm deletion:',
    mindCollect:{
      share:'Setting',
      defaultName:'Assignment Task Name',
      createTitleSetting:'Create Task Folder',
      openSummitTitle:'Allow Task File Submissions',
      allowViewTitle:'Allow Viewing File Contents',
      colletSetting:'Task Folder Settings',
      updateSetting:'Task Folder Settings',
      confirmDeleteCollectText:'Are you sure you want to delete this task folder? After deletion, it cannot be recovered, and all files in the folder will also be deleted!',
      templateTips:'Tips: After creation, you can click "Edit Template" to let users use it as a reference for submitting assignments',
    },
    mindCollectNormal:{
      createTitleSetting:'Create General Folder',
      createMindMap:'Create Mind Map',
      defaultName:'Folder Name',
      colletSetting:'General Folder Settings',
      updateSetting:'General Folder Settings',
      confirmDeleteCollectText:'Are you sure you want to delete this folder? After deletion, it cannot be recovered, and all files in the folder will also be deleted!',
    },
    enterShortUrl:'No login required, please enter the short code for mind map or task folder',
    cannotOpenShortUrl:'ClipCode does not exist or has expired',
    coworkModeNoteText:{
      task:"Task",
      viewLongVer:'Read-only view',
      editLongVer:'Collaborative co-editing',
      view:'View',
      edit:'Edit',
      closeView:'Close View',
    },
    moveToFolder:'Move to Folder',
    moveOutFolder:'Move Out of Folder',
    noFolder:'No Data Available',
    moveSuccess:'Move Successful',
    moveFail:'Move Failed',
    moveOutSuccess:'Successfully Moved Out',
    moveOutFail:'Failed to Move Out',
    createMindMapTask:'Create Mind Map Task',
    taskSuffix:'Task',
    template:'Template',
    refreshClipCode: "Refresh Clip Code",
    clipCodeStillValid: "Clip code already exists and has not expired, cannot update",
    checkClipCodeError: "Error occurred while checking clip code",
    clipCodeRefreshSuccess: "Clip code refreshed successfully",
    clipCodeRefreshError: "Failed to refresh clip code",
    clipCodeAutoUpdated: "Clip code has been automatically updated due to inactivity, please note!",
    gallerySubtitle: "What's on everyone's mind? See how others organize knowledge",
    heroTitle: "What ideas do you want to organize today?",
    heroSub: "Start from a template, or from a blank canvas — your call.",
    galleryHeroStats: "{count} mind maps in the library",
    galleryLoginBtn: "Start Creating",
    galleryTemplatesTitle: "{highlight} Examples",
    galleryTemplatesHighlight: "Classic",
    galleryTemplatesSub: "Click to explore and get inspired",
    galleryExploreTitle: "Explore Public Showcase",
    gallerySearchPlaceholder: "Search mind map name",
    galleryLoading: "Loading...",
    galleryEmpty: "No public mind maps yet",
    galleryLoadMore: "Load More",
    galleryTemplateCards: [
      { title: 'Study Notes', sub: 'Organize class notes' },
      { title: 'Brainstorm', sub: 'Free ideation' },
      { title: 'Project Planning', sub: 'WBS breakdown' },
      { title: 'Lesson Highlights', sub: 'Unit structure' },
      { title: 'Study Plan', sub: 'Track learning progress' },
    ],
  },
  currentUser: "Current User",
  privateInfo: "The current file owner has disabled sharing, viewing is not allowed",
  refreshHint: "Idle for more than 10 minutes, the system has been disconnected, please refresh the page",
  beforeDispoeHint: "Detected idle for more than 10 minutes, please click on the screen, otherwise it will be disconnected in 1 minute",
  inputEditKey:'Enter the edit password',
  sixBit:'6-bit character',
  closeMindCollect:'Collection has stopped',
  notAllowViewHint: "You are not allowed to view the submitted content. If you are an editor, please enter the editing code",
  allowEnterEditSuccess:'Edit password verification is successful, allowing entry to edit!',
  enterEditKeyWrong: "Edit password error. If you forget your password, please submit it again in the collection area, or request the password from the collection area administrator!",
  writeDownEditKey:'Please write down your edit code. You will need to enter the edit code next time you open it to edit:',
  reachMaxOpenFRUsage:'The current usage limit of shared documents has been reached, so new ones cannot be added. \n\t If you are the owner, please delete unnecessary documents and try adding new ones, or purchase an extended usage quota. If you do not have the right to delete, please ask the owner~',
  fluidRelayUsage:'Sharing Usage:',
  recentClick:'Recently Accessed',
  publicDisplay:'My Public Display',
  publicDeleteConfirm:'This cannot be undone. You will need to republish. Are you sure you want to delete?',
  owner:'Owner:',
  linkShareSuccess:'Mind map link has been successfully sent',
  linkShareCooldown:'Please wait 1 minute before sending mind map link again',
  mindCollectLinkShareSuccess:'Mind map assignment task link has been successfully sent',
  mindCollectLinkShareCooldown:'Please wait 1 minute before sending mind map assignment task link again',
  qrcodeTitle: 'Scan QR Code',
  qrcodeGenerateFailed: 'Failed to generate QR Code',
  copyToMine: {
    title: 'Save your mind map',
    btn: 'Save as My Mind Map',
    loginRequired: 'After logging in, you can',
    benefit1: 'Keep your edits',
    benefit2: 'Continue anytime',
    benefit3: 'Share and collaborate with others',
    goLogin: 'Go to Login',
    cancel: 'Cancel',
    success: 'Saved as My Mind Map!',
    failed: 'Save failed, please try again later',
    copyLabel: 'save',
  },
  playground: {
    title: 'Playground',
    homeBtn: 'Home',
    mindRoot: 'Create Freely',
    mindNode1: 'Curious Explorer',
    mindNode1a: 'Endless Possibilities',
    mindNode2: 'Smart Learner',
    mindNode2a: 'Daily Notes',
    mindNode3: 'Creative Mind',
    mindNode3a: 'Colorful Creation',
    mindNode3b: 'Doodle Away',
    mindNode4: 'Quick Thinker',
    mindNode4a: 'Start Right Now',
  },
};
